/*  MUI  */
import { Box, TableCell } from '@mui/material';

/*  Shared  */
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { ManagedTableHeaderFilter } from './ManagedTableHeaderFilter';
import { ManagedTableSortableArrows } from './ManagedTableSortableArrows';

export const ManagedTableHeaderCell = ({
    disabled,
    filters,
    header,
    setFilters,
    setPage,
    setSortState,
    sortState
}) => {
    const { t } = useTranslation();

    const { width, padding, paddingLeft, paddingRight, squish } = header;

    const sx = {
        backgroundColor: 'table.headerRowBackground',
        borderRight: 'none',
        overflowWrap: 'break-word',
        padding,
        paddingLeft,
        paddingRight,
        width
    };

    if (squish) {
        sx.marginLeft = '-10px';
    }

    if (header.sortable && sortState.key === header.sortableKey) {
        sx.borderBottom = '3px solid';
        sx.borderBottomColor = 'table.headerBorderSortable';
    }

    return (
        <TableCell
            align={header.align}
            colSpan={header.colSpan ? header.colSpan : 1}
            data-trackid="managedTableRenderHeaderCellTableCell"
            sx={sx}
        >
            <Box
                alignItems="center"
                data-testid="managedTableRenderHeaderCellBox"
                display="flex"
                justifyContent={
                    header.filterable || header.sortable
                        ? 'space-between'
                        : header.align
                }
            >
                <Box
                    display="flex"
                    alignItems="center"
                    data-testid="managedTableRenderHeaderCellBoxRenderHeader"
                    sx={{
                        ...(header.tooltip ? { whiteSpace: 'nowrap' } : {}),
                        fontWeight: 'bold'
                    }}
                >
                    {header.renderHeader}
                    {header.tooltip && (
                        <TooltipQ
                            className="no-print"
                            text={t(`Tooltips.${header.tooltip}`)}
                            size={FontSizes[1]}
                        />
                    )}
                </Box>
                {(header.filterable || header.sortable) && (
                    <Box display="flex" alignItems="center" ml="4px">
                        {header.filterable && (
                            <ManagedTableHeaderFilter
                                disabled={disabled}
                                filters={filters}
                                header={header}
                                setFilters={setFilters}
                                setPage={setPage}
                            />
                        )}
                        {header.sortable && (
                            <ManagedTableSortableArrows
                                disabled={disabled}
                                header={header}
                                setSortState={setSortState}
                                sortState={sortState}
                            />
                        )}
                    </Box>
                )}
            </Box>
        </TableCell>
    );
};
